import * as React from 'react';

import css from './PasswordForgot.module.scss';
import { buildUrl } from 'src/utils/request-url';

export const PasswordForgot = (props: { message: string }) => {
  return (
    <div className={css.PasswordForgot}>
      <a href={buildUrl('/password/reset_requests/new')}>{props.message}</a>
    </div>
  );
};
